import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { Check, X } from "lucide-react";

export default function AdminBills() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("moderation");
    const [busy, setBusy] = useState(false);

    const load = () => {
        const p = filter ? `?status=${filter}` : "";
        adminApi.get(`/api/admin/bills${p}`).then((r) => setItems(r.data.bills));
    };
    useEffect(load, [filter]);

    const moderate = async (id, action) => {
        setBusy(true);
        await adminApi.post(`/api/admin/bills/${id}/moderate`, { action });
        setBusy(false);
        load();
    };

    return (
        <div>
            <h1 className="font-display text-3xl font-bold">Bills & Fraud Queue</h1>
            <div className="flex gap-2 mt-4 mb-5">
                {[
                    ["", "All"],
                    ["moderation", "Moderation"],
                    ["approved", "Approved"],
                    ["rejected", "Rejected"],
                ].map(([k, l]) => (
                    <button
                        key={k}
                        data-testid={`admin-bill-filter-${k || "all"}`}
                        onClick={() => setFilter(k)}
                        className={`px-3 py-1.5 rounded-full text-sm ${
                            filter === k ? "bg-[#c9a959] text-black font-semibold" : "bg-[#f9fafb] text-[#374151] border border-[rgba(11,20,55,0.10)]"
                        }`}
                    >
                        {l}
                    </button>
                ))}
            </div>

            <div className="space-y-3">
                {items.length === 0 && (
                    <div className="fx-card p-8 text-center text-[#6b7280]">No bills</div>
                )}
                {items.map((b) => (
                    <div key={b.id} className="fx-card p-4">
                        <div className="flex items-center justify-between gap-3 flex-wrap">
                            <div>
                                <p className="font-semibold">
                                    {b.extracted?.merchant_name || "Unknown"} • ₹{b.extracted?.total || "—"}
                                </p>
                                <p className="text-xs text-[#6b7280]">
                                    {new Date(b.created_at).toLocaleString("en-IN")} • Inv {b.extracted?.invoice_number || "?"} •{" "}
                                    {b.customer?.mobile} ({b.customer?.loyalty_id})
                                </p>
                            </div>
                            <span
                                className={`fx-chip ${
                                    b.status === "approved"
                                        ? "bg-[#c9a959]/15 text-[#c9a959] border border-[#c9a959]/30"
                                        : b.status === "moderation"
                                        ? "bg-[#ffd700]/15 text-[#ffd700] border border-[#ffd700]/30"
                                        : "bg-[#ff4d4d]/15 text-[#ff4d4d] border border-[#ff4d4d]/30"
                                }`}
                            >
                                {b.status}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3 text-xs">
                            <Kv k="Fraud score" v={`${Math.round(b.fraud_score || 0)}/100`} />
                            <Kv k="Confidence" v={`${Math.round(b.confidence_score || 0)}%`} />
                            <Kv k="GSTIN" v={b.extracted?.gst_number || "—"} />
                            <Kv k="Points" v={b.points_awarded || 0} />
                        </div>
                        {b.fraud_signals?.notes?.length > 0 && (
                            <ul className="text-xs text-[#6b7280] mt-2 space-y-0.5 list-disc list-inside">
                                {b.fraud_signals.notes.map((n, i) => (
                                    <li key={i}>{n}</li>
                                ))}
                            </ul>
                        )}
                        {b.status === "moderation" && (
                            <div className="flex gap-2 mt-3">
                                <button
                                    onClick={() => moderate(b.id, "approve")}
                                    disabled={busy}
                                    data-testid={`approve-bill-${b.id}`}
                                    className="fx-btn-primary !py-2 !px-4 text-sm"
                                >
                                    <Check size={14} /> Approve
                                </button>
                                <button
                                    onClick={() => moderate(b.id, "reject")}
                                    disabled={busy}
                                    data-testid={`reject-bill-${b.id}`}
                                    className="fx-btn-ghost !py-2 !px-4 text-sm !text-[#ff4d4d]"
                                >
                                    <X size={14} /> Reject
                                </button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function Kv({ k, v }) {
    return (
        <div className="rounded-lg bg-white/[0.03] border border-[rgba(11,20,55,0.05)] px-3 py-2">
            <p className="text-[10px] uppercase tracking-widest text-[#6b7280]">{k}</p>
            <p className="text-[#0b1437] truncate">{v}</p>
        </div>
    );
}
